<template>
    <v-btn        
        text
        v-on:click="logOut"
      >
        <span class="mr-2 primary--text">Logout</span>
        <v-icon color="primary">mdi-logout</v-icon>
      </v-btn>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
    methods: {
        ...mapActions({
            signOut: 'auth/signOut'
        }),

        ...mapMutations({
            openDialog: 'form/setDialog',
            setDialogCard: 'form/setDialogCard',
            setDialogProgress: 'form/setDialogProgress',
            setOverlay: 'auth/setOverlay',
            setAuthenticated: 'auth/setAuthenticated',            
        }),

        async logOut () {            
            //this.openDialog(true);
            //this.setDialogCard(false);
            this.setOverlay(true);
            this.setAuthenticated(false);
            try {
                await this.signOut();
                console.log("logout complete");
            } catch (error) {
                if(error.response) console.log(error.response);
                else console.log(error);
            }            
            
            this.setOverlay(false); 
            this.$router.replace('/')
        }

        
    }
}
</script>